import { BrowserRouter } from "react-router-dom";
import RoutesMap from "./routes/RoutesMap";
import { store } from "./store/store.js";
import { Provider } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <RoutesMap />
      </Provider>
    </BrowserRouter>
  );
}

export default App;
